export default __webpack_public_path__ + "static/media/IMG_9045 copie.c222a865.jpg";